import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { post } from 'app/shared/utils/fetchr';
import { ActionExecutePayload } from 'app/modules/bankingIntegrations/requests';
import { sendErrorToast, sendSuccessToast } from 'app/shared/toasts/actions';

export const useExecuteAction = () => {
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: (payload: ActionExecutePayload) =>
      post('/banking-integrations/execute', payload),
    onSuccess: () => {
      dispatch(sendSuccessToast('Banking action executed successfully'));
    },
    onError: (err: Response) => {
      const defaultErrorMessage =
        'Failed to execute banking action. Please try again.';
      err
        .json()
        .then((errBody: { error_code?: string; message?: string }) => {
          if (
            errBody?.error_code === 'duplicate resource' &&
            errBody?.message
          ) {
            dispatch(sendErrorToast(errBody.message));
          } else {
            dispatch(sendErrorToast(defaultErrorMessage));
          }
        })
        .catch(() => {
          dispatch(sendErrorToast(defaultErrorMessage));
        });
    },
  });
};
